export default "__VITE_ASSET__C_hBEQGI__"